var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../../../../nunjucks.config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["front/utils/macros.jinja"] = require( "front/utils/macros.jinja" );
dependencies["front/components/MemberProfile/MemberProfileExperienceInner.jinja"] = require( "front/components/MemberProfile/MemberProfileExperienceInner.jinja" );




var shim = require("/var/www/django/adg.org/application/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["assets/app/front/components/MemberProfile/MemberProfileExperience.jinja"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
env.getTemplate("front/utils/macros.jinja", false, "assets/app/front/components/MemberProfile/MemberProfileExperience.jinja", false, function(t_2,t_1) {
if(t_2) { cb(t_2); return; }
t_1.getExported(function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
context.setVariable("macros", t_1);
output += "\n\n";
env.getTemplate("front/components/MemberProfile/MemberProfileExperienceInner.jinja", false, "assets/app/front/components/MemberProfile/MemberProfileExperience.jinja", false, function(t_5,t_4) {
if(t_5) { cb(t_5); return; }
t_4.getExported(function(t_6,t_4) {
if(t_6) { cb(t_6); return; }
if(Object.prototype.hasOwnProperty.call(t_4, "MemberProfileExperienceInner")) {
var t_7 = t_4.MemberProfileExperienceInner;
} else {
cb(new Error("cannot import 'MemberProfileExperienceInner'")); return;
}
context.setVariable("MemberProfileExperienceInner", t_7);
output += "\n\n";
var macro_t_8 = runtime.makeMacro(
[], 
["data", "isOwner"], 
function (kwargs) {
var callerFrame = frame;
frame = new runtime.Frame();
kwargs = kwargs || {};
if (Object.prototype.hasOwnProperty.call(kwargs, "caller")) {
frame.set("caller", kwargs.caller); }
frame.set("data", Object.prototype.hasOwnProperty.call(kwargs, "data") ? kwargs["data"] : {});frame.set("isOwner", Object.prototype.hasOwnProperty.call(kwargs, "isOwner") ? kwargs["isOwner"] : false);var t_9 = "";t_9 += "\n    <div class=\"MemberProfile-block MemberProfileExperience\">\n        <div class=\"MemberProfileExperience-wrapper\">\n            ";
t_9 += runtime.suppressValue((lineno = 7, colno = 41, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "MemberProfileExperienceInner"), "MemberProfileExperienceInner", context, [runtime.makeKeywordArgs({"data": runtime.contextOrFrameLookup(context, frame, "data"),"isOwner": runtime.contextOrFrameLookup(context, frame, "isOwner")})])), env.opts.autoescape);
t_9 += "\n        </div>\n    </div>\n";
;
frame = callerFrame;
return new runtime.SafeString(t_9);
});
context.addExport("MemberProfileExperience");
context.setVariable("MemberProfileExperience", macro_t_8);
output += "\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})})})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["assets/app/front/components/MemberProfile/MemberProfileExperience.jinja"] , dependencies)


//////////////////
// WEBPACK FOOTER
// ./assets/app/front/components/MemberProfile/MemberProfileExperience.jinja
// module id = 101
// module chunks = 0